import { useContext, useState as classicUseState } from 'react';
import { GlobalMenu } from '@components';
import { NavigationContext } from '@layout/navigation/navigation';
import { InviteUserRole } from '@models/Invite.model';
import { Container } from './AddNewMenu.styles';
import { AddTagDialog } from './Components/AddTagDialog/AddTagDialog';
import { AddCategorieDialog } from './Components/AddCategorieDialog/AddCategorieDialog';

const AddNewMenu = () => {
  const [openAddTagDialog, setOpenAddTagDialog] =
    classicUseState<boolean>(false);
  const [openAddCategorieDialog, setOpenAddCategorieDialog] =
    classicUseState<boolean>(false);

  const { role } = useContext(NavigationContext);

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Add new..."
        menuIcon="plus"
        hoverColor="transparent"
        width="42px"
        height="42px"
        paddingTop="11px"
        itemList={[
          {
            disabled: ![InviteUserRole.ADMIN, InviteUserRole.EDITOR].includes(
              role,
            ),
            disableToolTip: [
              InviteUserRole.ADMIN,
              InviteUserRole.EDITOR,
            ].includes(role),
            toolTipText: 'Only Admins or Editors can add a category',
            toolTipId: 'addTagTooltip',
            label: 'Tag',
            iconName: 'tag',
            onClick: () => {
              setOpenAddTagDialog(true);
            },
          },
          {
            disabled: ![InviteUserRole.ADMIN].includes(role),
            disableToolTip: [InviteUserRole.ADMIN].includes(role),
            toolTipText: 'Only Admins can add a category',
            toolTipId: 'editCategoryTooltip',
            label: 'Tag Category',
            iconName: 'folder-new',
            onClick: () => {
              setOpenAddCategorieDialog(true);
            },
          },
        ]}
      />

      <AddTagDialog
        open={openAddTagDialog}
        onClose={() => {
          setOpenAddTagDialog(false);
        }}
      />

      <AddCategorieDialog
        open={openAddCategorieDialog}
        onClose={() => {
          setOpenAddCategorieDialog(false);
        }}
      />
    </Container>
  );
};

export { AddNewMenu };
